import React, {Component} from 'react'
import ClearFilters from './clear-filters'
import Refinements from './refinements'
import CustomDropdownSortby from './dropdown-sort-by'
import DropdownMenuSelect from './new-menu-select'
import {isAu, isCa} from '@/scripts/util/countryCheck'

export default class AlgoliaCollectionFilters extends Component {
    constructor(props) {
        super(props)
        this.state = {
            product_subcat: 50,
            brand: 50,
            location: 10,
            gas_type: 5,
            sale_status: 2
        }

        this.changeLimit = this.changeLimit.bind(this)
        this.algoliaConfig = this.props.algoliaConfig
    }

    changeLimit(menuItem) {
        let newValue = this.state[menuItem] + 10
        this.setState({[menuItem]: newValue})
    }

    render() {
        const {
            changeResultsIndex,
            collection,
            setNumberRefinements,
            refinementCount,
            activeAlgoliaIndex,
            enableSearchedFacets
        } = this.props
        
        const showCategoryfilter = () => {
            const allowedCollectionHandles = [
                `${isCa() ? `used-commercial-kitchen` : `all`}-equipment`,
                `hot-deals`,
                `certified-used-equipment`, // AU cert used pages
                `used-commercial-kitchen-equipment`, // NZ used pages
            ]
            
            return (!window.location.pathname.endsWith(`search`) &&
                    collection &&
                    allowedCollectionHandles.includes(collection.handle))
        }

        return (
            <div className="filters">
                <div className="sort-by-list small-show">
                    <div className="seperator"></div>
                    <CustomDropdownSortby
                        changeResultsIndex={changeResultsIndex}
                        defaultRefinement={activeAlgoliaIndex}
                        items={this.algoliaConfig.sortOptions}
                    />
                </div>
                <div className="filters-title">
                    <p>Filters</p>
                    { refinementCount ? (
                        <ClearFilters/>
                    ) : null }

                </div>

                <div className="filter-list flex">
                    { showCategoryfilter() && (
                        <DropdownMenuSelect
                            changeLimit={this.changeLimit}
                            limit={500}
                            attribute="named_tags.cat"
                            label="Product Category"
                            dropdown="product_cat"
                        />
                    ) }
                    <DropdownMenuSelect
                        changeLimit={this.changeLimit}
                        limit={500}
                        attribute="named_tags.subcat"
                        label="Product Type"
                        dropdown="product_subcat"
                        searchable={enableSearchedFacets}
                        searchablePlaceholder={`Search Product Types`}
                    />
                    <DropdownMenuSelect
                        changeLimit={this.changeLimit}
                        attribute="vendor"
                        label="Brand"
                        dropdown="brand"
                        limit={5000}
                        searchable={enableSearchedFacets}
                        searchablePlaceholder={`Search Brands`}
                    />
                    <DropdownMenuSelect
                        changeLimit={this.changeLimit}
                        attribute="named_tags.shopcondition"
                        label="Product Condition"
                        dropdown="product_condition"
                    />
                    <DropdownMenuSelect
                        changeLimit={this.changeLimit}
                        attribute="named_tags.locfilter"
                        label="Location"
                        dropdown="location"
                        limit={10}
                        showMore={true}
                        showMoreLimit={this.state.location}
                        expanded={true}
                        searchable={false}
                    />
                    {isAu() ? (<DropdownMenuSelect
                        changeLimit={this.changeLimit}
                        attribute="named_tags.gas"
                        label="Power Type"
                        dropdown="gas_type"
                        limit={5}
                        showMore={true}
                        showMoreLimit={this.state.gas_type}
                        searchable={false}
                    />) : null}
                    <DropdownMenuSelect
                        changeLimit={this.changeLimit}
                        attribute="named_tags.sale_status"
                        label="Sale Status"
                        dropdown="sale_status"
                        limit={10}
                        showMore={true}
                        showMoreLimit={this.state.sale_status}
                        searchable={false}
                    />
                </div>
                <Refinements
                    clearsQuery={true}
                    setNumberRefinements={setNumberRefinements}
                    refinementCount={refinementCount}
                />
            </div>
        )
    }
}
